export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const CHECK_JWT_REQUEST = 'CHECK_JWT_REQUEST';
export const CHECK_JWT_SUCCESS = 'CHECK_JWT_SUCCESS';
export const CHECK_JWT_FAILURE = 'CHECK_JWT_FAILURE';

export const SELECT_ROLE_REQUEST = 'SELECT_ROLE_REQUEST';